import { useContext, useEffect } from 'react';
import { DoubtsAIContext } from '@context/DoubtsAIContext';
import useDoubtSolution from './useDoubtSolution';

const useImageAiSolution = ({ goalUID }) => {
  const { addMessage, doubtsUID, imageAiResponse, setFlowType } =
    useContext(DoubtsAIContext);

  const { doubtSolutionResult } = useDoubtSolution({
    goalUID,
    doubtUID: doubtsUID
  });
  useEffect(() => {
    if (
      doubtSolutionResult === 'success' &&
      imageAiResponse?.solution?.[0].content
    ) {
      addMessage({
        id: 123,
        text: imageAiResponse?.solution?.[0].content,
        sender: 'bot',
        timestamp: new Date(),
        type: imageAiResponse?.solution?.[0].content_type,
        isDoubtImageResponse: true
      });
      setFlowType('questionOptions');
    } else if (doubtSolutionResult === 'failure') {
      addMessage({
        id: Date.now(),
        text: imageAiResponse?.solution?.[0].content,
        sender: 'bot',
        timestamp: new Date(),
        type: imageAiResponse?.solution?.[0].content_type
      });
      setFlowType('questionOptions');
    }
  }, [addMessage, doubtSolutionResult, imageAiResponse?.solution, setFlowType]);
};

export default useImageAiSolution;
